// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/aggregators_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Aggregator } from '../../aggregators/v1/aggregator_pb';
import { file_aggregators_v1_aggregator } from '../../aggregators/v1/aggregator_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/aggregators_response.proto.
 */
export const file_responses_v1_aggregators_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CidyZXNwb25zZXMvdjEvYWdncmVnYXRvcnNfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSKyAQoTQWdncmVnYXRvcnNSZXNwb25zZRJBCgthZ2dyZWdhdG9ycxgBIAMoCzIsLnJlc3BvbnNlcy52MS5BZ2dyZWdhdG9yc1Jlc3BvbnNlLkFnZ3JlZ2F0b3IaWAoKQWdncmVnYXRvchIKCgJpZBgBIAEoBBIoCgRuYW1lGAIgASgOMhouYWdncmVnYXRvcnMudjEuQWdncmVnYXRvchIUCgx0cmFuc2F0ZV9rZXkYAyABKAlCgwEKEGNvbS5yZXNwb25zZXMudjFCGEFnZ3JlZ2F0b3JzUmVzcG9uc2VQcm90b1ABWgQuL3BiogIDUlhYqgIMUmVzcG9uc2VzLlYxygIMUmVzcG9uc2VzXFYx4gIYUmVzcG9uc2VzXFYxXEdQQk1ldGFkYXRh6gINUmVzcG9uc2VzOjpWMWIGcHJvdG8z',
        [file_aggregators_v1_aggregator]
    );

/**
 * @generated from message responses.v1.AggregatorsResponse
 */
export type AggregatorsResponse = Message<'responses.v1.AggregatorsResponse'> & {
    /**
     * @generated from field: repeated responses.v1.AggregatorsResponse.Aggregator aggregators = 1;
     */
    aggregators: AggregatorsResponse_Aggregator[];
};

/**
 * Describes the message responses.v1.AggregatorsResponse.
 * Use `create(AggregatorsResponseSchema)` to create a new message.
 */
export const AggregatorsResponseSchema: GenMessage<AggregatorsResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_aggregators_response, 0);

/**
 * @generated from message responses.v1.AggregatorsResponse.Aggregator
 */
export type AggregatorsResponse_Aggregator = Message<'responses.v1.AggregatorsResponse.Aggregator'> & {
    /**
     * @generated from field: uint64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: aggregators.v1.Aggregator name = 2;
     */
    name: Aggregator;

    /**
     * @generated from field: string transate_key = 3;
     */
    transateKey: string;
};

/**
 * Describes the message responses.v1.AggregatorsResponse.Aggregator.
 * Use `create(AggregatorsResponse_AggregatorSchema)` to create a new message.
 */
export const AggregatorsResponse_AggregatorSchema: GenMessage<AggregatorsResponse_Aggregator> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_aggregators_response, 0, 0);
